export function childAgeCSVStringToNumberArray(ageString) {
  return ageString
    .split(',')
    .map((age) => parseInt(age, 10))
    .filter((age) => !isNaN(age))
}
